export default {
  filters: {
    managers: {
      placeholder: 'Manageri de vânzări',
    },
  },
  metrics: {
    collected_commission: 'Comision total',
  },
  fields: {
    manager: 'Manager',
    area: 'Locație',
    total_amount: 'Câștiguri',
    companies_live: 'Live',
    restaurant: 'Restaurant',
    live_from: 'Activ din',
    plan_amount: 'Sumă plan',
    prepayment_bonus_amount: 'Bonus plată în avans',
    lead_source_bonus_amount: 'Bonus sursă lead',
    google_business_bonus_amount: 'Bonus conectare Google Business',
    promo_code_bonus_amount: 'Bonus cod promoțional master',
    smart_pricing_bonus_amount: 'Bonus prețuri inteligente',
    mobile_app_bonus_amount: 'Bonus aplicație mobilă',
    sales_goal_bonus_amount: 'Bonus obiectiv vânzări',
  },
  buttons: {
    export: 'Export',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
